(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesDialogController', LicencesDialogController);

    LicencesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Licences', 'TabDomains'];

    function LicencesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Licences, TabDomains) {
        var vm = this;
        vm.licences = entity;
        vm.tabdomains = TabDomains.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:licencesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.licences.id !== null) {
                Licences.update(vm.licences, onSaveSuccess, onSaveError);
            } else {
                Licences.save(vm.licences, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
